export default class StructureSvgLoader {
    static NO_STRUCTURE_SVG = `
        <svg height="100%" width="100%">
          <text x="50%" y="50%" text-anchor="middle" style="font-size: 24px; fill: gray">No structure</text>
        </svg>`;
    #httpClient;
    /**
     * This cache is used to store already parsed and prepared the SVGs of the structures that have been loaded.
     * We can't use the browser's cache because it saves only byte responses, so we would have to parse the SVGs again.
     * @type {Map<any, any>}
     */
    #cache = new Map();

    constructor(httpClient) {
        this.#httpClient = httpClient;
    }

    /**
     * @param {string} urlPath
     * @return {Promise<string>}
     */
    async getByUrlPath(urlPath) {
        if (urlPath == null)
            return Promise.resolve(StructureSvgLoader.NO_STRUCTURE_SVG);
        if (typeof urlPath === "string" && urlPath.length > 0) {
            if (!(urlPath.startsWith("/api/substance/") || urlPath.startsWith("/api/attachment/structure/")) || !urlPath.endsWith(".svg")){
                throw new Error("Invalid uri: " + urlPath);
            }
            const cached = this.#cache.get(urlPath);
            if (cached)
                return cached;
            const response = await this.#httpClient
                .fetch(urlPath, {
                    method: 'GET',
                    headers: {
                        "Accept": "img/svg+xml"
                    },
                    responseType: 'document'
                });
            let svg = response.querySelector('svg');
            if (!svg)
                throw new Error("There is no svg on the path: " + urlPath);
            svg.setAttribute('width', '100%');
            svg.setAttribute('height', '100%');
            let result = new XMLSerializer().serializeToString(response);
            this.#cache.set(urlPath, result);
            return result;
        } else {
            throw new Error("Invalid uri: " + urlPath);
        }
    }
}